<template>
    <div class="teams-config">
        <h3 class="teams-config-title">
            {{ $t('teams_apps.select_a_portfolio_project_that_you_want_to_link_to_this_tab') }}
        </h3>

        <b-form-group
            class="teams-school-season-select"
            :label="$t('teams_apps.select_grade')"
            label-for="teams-school-season-select">
            <design-2021-apprentice-multiselect-component
                class="apprentice-select with-border teams-config-select"
                id="teams-school-season-select"
                v-model="selectedSeason"
                :multiple-select="false"
                track-by="id"
                label="season"
                ref="test"
                :options="seasonsIn"
                @input="updateGroupOptions"
                :allow-empty="false"
                :show-labels="false">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            class="teams-school-group-select"
            :label="$t('teams_apps.choose_a_main_group')"
            label-for="teams-school-group-select">
            <design-2021-apprentice-multiselect-component
                class="apprentice-select with-border teams-config-select"
                id="teams-school-group-select"
                v-model="selectedGroup"
                ref="groupSelect"
                :multiple-select="false"
                label="name"
                track-by="id"
                :options="groupOptions"
                @input="updatechildGroupOptions"
                :show-labels="false"
                :placeholder="
                    groupOptions.length === 0 ? $t('teams_apps.no_main_groups_found') : $t('teams_apps.make_a_choice')
                "
                :allow-empty="false"
                :disabled="groupOptions.length === 0">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            class="teams-school-sub-group-select"
            v-if="childGroupOptions.length > 0"
            :label="$t('teams_apps.choose_a_subgroup')"
            label-for="teams-school-child-group-select">
            <design-2021-apprentice-multiselect-component
                class="apprentice-select with-border teams-config-select"
                id="teams-school-child-group-select"
                v-model="selectedChildGroup"
                :multiple-select="false"
                label="name"
                :options="childGroupOptions"
                :show-labels="false"
                :placeholder="
                    !childGroupOptions.length
                        ? $t('teams_apps.no_subgroups_found')
                        : $t('teams_apps.no_subgroups_found')
                "
                :disabled="!childGroupOptions.length"
                @input="readyToSubmit">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>
    </div>
</template>

<script>
import { app, pages } from '@microsoft/teams-js';

export default {
    name: 'teams-config-component',
    props: {
        uuidIn: {
            type: String,
            required: true,
        },
        seasonsIn: {
            type: Array,
            required: true,
        },
        currentSeasonIdIn: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectedSeason: this.seasonsIn.find((season) => season.id === this.currentSeasonIdIn),
            selectedMainGroup: null,
            selectedGroup: null,
            selectedChildGroup: null,
            groupOptions: [],
            childGroupOptions: [],
        };
    },

    mounted() {
        app.initialize();
        this.updateGroupOptions(this.selectedSeason);
    },

    methods: {
        updateGroupOptions(season) {
            this.axios.get(this.routes.groupMainPerSeason(season.id)).then(
                (response) => {
                    this.groupOptions = response.data;
                    this.selectedGroup = null;
                    this.selectedChildGroup = null;
                    pages.config.setValidityState(false);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updatechildGroupOptions(group) {
            this.axios.get(this.routes.groupSubGroupPerSeason(group.id, this.selectedSeason.id)).then(
                (response) => {
                    this.childGroupOptions = response.data;
                    this.selectedChildGroup = null;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
            this.submit();
        },

        readyToSubmit() {
            this.submit();
        },

        hasErrors() {
            if (!this.selectedSeason) {
                return true;
            }

            if (!this.selectedGroup) {
                return true;
            }

            return false;
        },

        submit() {
            if (this.hasErrors()) {
                pages.config.setValidityState(false);
                return;
            }

            app.getContext().then((success) => {
                const uuid = success.page.id ? success.page.id : this.uuidIn;
                const data = {
                    teams_team_id: uuid,
                    group_id: this.selectedGroup.id,
                    child_group_id: this.selectedChildGroup ? this.selectedChildGroup.id : null,
                };

                this.axios.post(this.routes.teamsPortfolioConfigStore(), data).then(
                    (response) => {
                        pages.config.setValidityState(true);
                        pages.config.registerOnSaveHandler((saveEvent) => {
                            pages.config
                                .setConfig({
                                    contentUrl: this.routes.baseUrl() + '/teams-app/landing/portfolio_show',
                                    suggestedDisplayName: 'Portfolio',
                                    entityId: uuid,
                                })
                                .then(
                                    (result) => {
                                        saveEvent.notifySuccess();
                                    },
                                    (error) => {
                                        saveEvent.notifyFailure(this.$t('teams_apps.unexpected_error'));
                                    },
                                );
                        });
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            });
        },
    },
};
</script>

<style scoped lang="scss">
.teams-config-title {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.teams-config-select {
    padding: 0;
    margin-bottom: $grid-gutter-width;
}
</style>
